import ToggleElementController from "./toggle_element_controller";

export default class extends ToggleElementController {
  toggleOne(event) {
    this.stimulate("Billing::SendInvoice#validate_installation_for_invoice", event.currentTarget).then((payload) => {
      super.toggleOne(event);
    });
  }
}
